import type { TLoginResponse } from 'src/types/auth';
import type { TUser } from 'src/types/user';

import { createContext } from 'react';

export interface State {
  isInitialized: boolean;
  isAuthenticated: boolean;
  user: Partial<TUser> | null;
}

export const initialState: State = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

export interface AuthContextType extends State {
  setInfo: (data: TLoginResponse['data']['info']) => void;
  signIn: (data: TLoginResponse['data']['info']) => void;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  ...initialState,
  setInfo: () => {
    //implement code here
  },
  signIn: () => {
    //implement code here
  },
  signOut: () => {
    //implement code here
  },
});
